import React, { useEffect, useState } from "react";
import { insertDataJson, updateItem, getData } from "../Tools/helpers";
import Alert from "@mui/material/Alert";
import { PageTitle } from "../components/PageHeader";

import TableHistoryCustom from "../components/TableHistoryCustom";
import DialogCustom from "../components/DialogCustom";

const Entry = () => {
  const [isDialog, setIsDialog] = useState(false);
  const [itemCancel, setItemCancel] = useState(0);
  const [dataEntries, setDataEntries] = useState({
    method_payment: 0,
    amount: 0,
    description: "",
    dispatch: "",
    type: "",
    staff_id: 0,
  });
  const [data, setData] = useState([]);
  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const getEntries = async () => {
    const route = "Entry";
    const send = await getData(route);
    if (send.code === 200) {
      setData(send.data);
    }
  };

  const setIds = async () => {
    const user = await JSON.parse(localStorage.getItem("USER_IUMV"));
    setDataEntries({
      ...dataEntries,
      university_id: user.university_id,
      staff_id: user.staff_id,
    });
  };

  const setState = (e) => {
    setDataEntries({
      ...dataEntries,
      [e.target.name]: e.target.value,
    });
  };

  const [fileBase64, setFileBase64] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileSizeError, setFileSizeError] = useState(false);
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (
        file.type === 'application/pdf' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        if (file.size <= 3 * 1024 * 1024) {
          const reader = new FileReader();

          reader.onload = (e) => {
            setFileBase64(e.target.result);
            setFileName(file.name);
            setFileSizeError(false);
          };

          reader.readAsDataURL(file);
        } else {
          setMessage({
            status: true,
            message: "El archivo no debe pesar más de 3M",
            label: "error",
          });
        }
      } else {
        alert('El tipo de archivo no es válido. Se requiere PDF, XLS o XLSX.');
      }
    }
  };

  const FieldsCustomTable = [
    { name: "id", label: "ID" },
    { name: "name", label: "Campus" },
    { name: "description", label: "Concepto" },
    { name: "register_date", label: "Fecha" },
    { name: "amount", label: "Importe" },
    { name: "dispatch", label: "Entregó" },
    { name: "method_payment", label: "Forma de pago" },
    { name: "status_description", label: "Estatus" },
    { name: "approved_by", label: "Apropado por" },
    { name: "approved_date", label: "Fecha aprobación" },
    { name: "status", label: "" },
  ];

  const saveEntry = async () => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    if (
      // dataEntries.method_payment === 0 ||
      dataEntries.amount === 0 ||
      dataEntries.amount === "" ||
      fileBase64 === null
    ) {
      setMessage({
        status: true,
        message: "Todos los campos son requeridos",
        label: "error",
      });
      return;
    }

    setMessage({
      status: true,
      message: "Guardando...",
      label: "info",
    });

    const route = "Entry";
    const newData = {
      file: fileBase64,
      amount: dataEntries.amount,
      university_id: dataEntries.university_id,
      staff_id: dataEntries.staff_id
    }
    const send = await insertDataJson(route, newData);

    if (send.code === 201) {
      setMessage({
        status: true,
        message: "Se ha guardado correctamente",
        label: "success",
      });
      getEntries();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  const activeDialog = (row) => {
    setItemCancel(row);
    setIsDialog(true);
  };

  const cancelEntry = async (option) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    setIsDialog(false);
    if (!option) {
      return;
    }
    setMessage({
      status: true,
      message: "Cancelando...",
      label: "info",
    });

    const dataStatus = {
      status: 1,
    };

    const route = "Entry";
    const send = await updateItem(`${route}/${itemCancel.id}`, dataStatus);
    if (send.code === 200) {
      setMessage({
        status: true,
        message: "Se ha cancelado correctamente",
        label: "success",
      });
      getEntries();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  const downloadFileEntry = async (item) => {
    const route = "DownloadFileEntry";
    const send = await getData(`${route}/${item.id}`);
    if (send.code === 200) {
      var a = document.createElement("a");
      a.href = send.data;
      a.download = `${item.name}_${item.dispatch}_${item.register_date}`;
      a.click();
    }
  };

  useEffect(() => {
    setIds();
    getEntries();
  }, []);

  const inputStyle = {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.85rem',
    color: '#111827',
    outline: 'none',
    backgroundColor: '#fff',
    transition: 'border-color 0.15s',
  };

  return (
    <div>
      <DialogCustom
        open={isDialog}
        message={{ title: "Cancelar", message: "¿Desea cancelar el registro de efectivo?" }}
        action={cancelEntry}
      />

      <PageTitle>Entrega de Efectivo</PageTitle>

      {/* Form card */}
      <div style={{
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '20px 24px',
        marginTop: '16px',
        marginBottom: '24px',
        maxWidth: '480px',
      }}>
        {/* Card header */}
        <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '18px' }}>
          <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Nuevo Registro
          </span>
        </div>

        {/* Importe */}
        <div style={{ marginBottom: '14px' }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#374151', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Importe
          </label>
          <input
            style={inputStyle}
            type="number"
            name="amount"
            value={dataEntries.amount}
            onChange={setState}
            onFocus={e => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.1)'; }}
            onBlur={e => { e.target.style.borderColor = '#d1d5db'; e.target.style.boxShadow = 'none'; }}
            placeholder="0.00"
          />
        </div>

        {/* Archivo */}
        <div style={{ marginBottom: '6px' }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#374151', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Archivo <span style={{ color: '#9ca3af', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(PDF, XLS, XLSX — máx. 3 MB)</span>
          </label>
          <div style={{
            border: '1px dashed #d1d5db',
            borderRadius: '6px',
            padding: '12px 14px',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}>
            <i className="fa-solid fa-paperclip" style={{ color: '#9ca3af', fontSize: '14px', flexShrink: 0 }}></i>
            <div style={{ flex: 1, minWidth: 0 }}>
              {fileName
                ? <span style={{ fontSize: '0.78rem', color: '#111827', fontWeight: 500 }}>{fileName}</span>
                : <span style={{ fontSize: '0.78rem', color: '#9ca3af' }}>Ningún archivo seleccionado</span>
              }
            </div>
            <label style={{
              cursor: 'pointer',
              fontSize: '0.72rem',
              fontWeight: 600,
              color: '#374151',
              backgroundColor: '#f1f5f9',
              border: '1px solid #d1d5db',
              borderRadius: '5px',
              padding: '4px 10px',
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}>
              Examinar
              <input type="file" accept=".pdf, .xls, .xlsx" onChange={handleFileChange} style={{ display: 'none' }} />
            </label>
          </div>
        </div>

        {/* Alert */}
        {message.status && (
          <Alert className="mt-3" severity={message.label}>
            {message.message}
          </Alert>
        )}

        {/* Submit button */}
        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={() => saveEntry()}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              backgroundColor: '#111827',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              padding: '9px 22px',
              fontSize: '0.78rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#111827'; }}
          >
            <i className="fa-solid fa-plus" style={{ fontSize: '11px' }}></i>
            Agregar
          </button>
        </div>
      </div>

      <TableHistoryCustom
        fields={FieldsCustomTable}
        data={data}
        actionType={["cancel", "downloadFileEntry"]}
        action={activeDialog}
        action2={downloadFileEntry}
      />
    </div>
  );
};

export default Entry;
